const state = {
    dutiesDescription: [
        // {
        //     description: '',
        //     activityType: '', // جاری و موردی و سه نقطه
        //     repetitionFrequency: '', // ماهانه / سه ماهه / شش ماهه / سالانه / سه نقطه
        //     importance: '', // خیلی زیاد، زیاد، متوسط، کم، خیلی کم
        //     difficultyLearning: '', // خیلی زیاد، زیاد، متوسط، کم، خیلی کم
        // },
    ],
};

const mutations = {
    setDutiesDescription(state, value) {
        state.dutiesDescription = value;
    },
};

const actions = {};

const getters = {
    dutiesDescription: (state) => state.dutiesDescription,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
